import dayjs from "dayjs";
import { Clock } from "lucide-react";

export const isLateEntry = (serviceDate, createdAt) =>
  !!serviceDate && !!createdAt && dayjs(createdAt).diff(dayjs(serviceDate), "hour") > 48;

export const isPastDate48h = (serviceDate) =>
  !!serviceDate && dayjs().diff(dayjs(serviceDate), "hour") > 48;

export function LateEntryChip({ id }) {
  return (
    <span data-testid={`late-entry-chip-${id || "x"}`} title="Documented more than 48 hours after the service date (CMS late entry)"
      className="inline-flex items-center gap-1 rounded-full bg-[#FFF3E0] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#B84A00]">
      <Clock size={10} /> Late Entry
    </span>
  );
}

export function LateEntryWarning({ date }) {
  if (!isPastDate48h(date)) return null;
  return (
    <div data-testid="late-entry-warning" className="flex items-start gap-2 rounded-xl border border-[#FFE0B2] bg-[#FFF8E1] px-3.5 py-2.5 text-xs text-[#6D4C41]">
      <Clock size={14} className="mt-0.5 shrink-0 text-[#B84A00]" />
      <span><b className="text-[#B84A00]">Late entry:</b> this document is dated more than 48 hours in the past. It will be flagged as a LATE ENTRY, and the audit trail records today as the actual entry time (CMS documentation integrity guidelines).</span>
    </div>
  );
}
